import { axiosInstance } from '@/components/axiosInstance'

export const fetchDocument = (document: string) => {
  return axiosInstance.get(document)
}

export const insertFetchedDocument = (
  targetContainer: HTMLElement | null,
  htmlElement: any
) => {
  if (targetContainer === null) {
    return
  }

  targetContainer.appendChild(htmlElement)
}

export const dataToHtmlElement = (htmlElement: string): HTMLElement => {
  const parser = new DOMParser()
  return parser
    .parseFromString(htmlElement, 'text/html')
    .getElementById('swiftaid-legal-doc-target-content') as HTMLElement
}
